<template>
  <div class="first-bloc">
    <div class="name-table">
      {{ name_table }}
    </div>
    <div class="dep-temp">
      <InputSwitch v-model="dep_temperature"/>
      <div style="margin: 0 0.8rem;">Temperature dependent</div>
    </div>
  </div>

  <div>
    <ul v-if="dep_temperature" style="display: flex; flex-direction: row; justify-content: flex-start;">
      <li>
        <div style="width: 172px; height: 33px; display: table-cell; vertical-align: middle; font-weight: bold;">Start
          (K)
        </div>
      </li>
      <li>
        <div style="width: 172px; height: 33px; display: table-cell; vertical-align: middle; font-weight: bold;">End
          (K)
        </div>
      </li>
      <li>
        <div style="width: 172px; height: 33px; display: table-cell; vertical-align: middle; font-weight: bold;">
          {{ unityName }}
        </div>
      </li>
      <li v-if="dep_temperature" style="width: 75px;">
        <Button icon="pi pi-plus" class="p-button-raised p-button-rounded" @click="addLine" style="margin: 1px;"/>
        <br>
        <Button icon="pi pi-minus" class="p-button-raised p-button-rounded" @click="removeLine" v-if="countLine > 1"
                style="margin: 1px;"/>
      </li>
      <li v-else>
        <div style="width:40px;"></div>
      </li>
    </ul>
    <div v-if="dep_temperature">
      <LineTable v-for="line in countLine" :key="line" @data="dataTemp(line, $event)" ref="linetable" :unity="unity"/>
    </div>
    <div v-else>
      <div style="height: 2.5rem;"/>
      <InputText style="width:27rem;" v-model="no_temp" @focusout="dataWithoutTemp"
                 :class="{ 'p-invalid': no_temp_empty }"/>
      <label style="margin: 0 0.8rem;">{{ unity }}</label>
    </div>
  </div>
</template>

<script>
import LineTable from '@/components/line_table.vue';

export default {
  name: 'TableMesure',
  components: {
    LineTable
  },
  emits: ["datas"],
  props: {
    name_table: String,
    unityName: String,
    unity: String,
  },
  data() {
    return {
      datasDict: {},
      countLine: 1,
      dep_temperature: true,
      no_temp: '',
      no_temp_empty: false,
      control: true,
    }
  },
  methods: {
    dataWithoutTemp() {
      let data = {1: {"density": this.no_temp}}
      this.$emit('datas', data)
    },
    clearAll() {
      this.countLine = 1
      if (this.dep_temperature) {
        this.$refs.linetable[0].clearAll()
      }
      this.dep_temperature = true
      this.no_temp = ''
    },
    dataTemp(line, dataList) {
      this.datasDict[line] = dataList
      this.$emit('datas', this.datasDict)
    },
    addLine() {
      this.countLine++
    },
    removeLine() {
      delete this.datasDict[this.countLine]
      this.$emit('datas', this.datasDict)
      this.countLine--
    },
    controlEmpty() {
      this.control = true
      if (this.dep_temperature) {
        for (let i = 0; i < this.countLine; i++) {
          let ctrl = this.$refs.linetable[i].control_empty()
          if (ctrl === false) {
            this.control = false
          }
        }
      } else {
        if (this.no_temp === '') {
          this.no_temp_empty = true
          this.control = false
        }
      }

      return this.control
    },
  },
  watch: {
    dep_temperature() {
      this.countLine = 1
    },
    no_temp() {
      if (this.no_temp !== '') {
        this.no_temp_empty = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.first-bloc {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 2rem;
}

.dep-temp {
  display: flex;
  align-items: center;
}

h3 {
  margin: 40px 0 0;
}

ul {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.p-component {
  opacity: 1 !important;
  font-size: 90% !important;
}
</style>
